<div *ngIf="crmItem && alarmDate" class="crm-timer">Closes in: <span class="crm-timer-value">{{ alarmDate | crmAge }}</span></div>
